import {computeIsTableLocked} from 'notebook/tables/store/logic/TableLockingLogic';
import {createTableModelSelector} from 'notebook/tables/store/selectors/util/SelectorCreators';
import {TableEditableStore} from 'notebook/tables/store/TableStore';

/**
 * Model containing properties related to table locking and permissions about the editability of the table.
 */
export interface TableLockingModel {
  /**
   * Whether the table is in a locked state.
   * A table is locked if the locked prop is true OR if it has placeholder rows.
   */
  isTableLocked: boolean;

  /*
  TODO(BNCH-146929): Future properties to be added as logic is transitioned out of TableEditable:
  isCellSelectionLocked: boolean; // From _isCellSelectionEditingLocked()
  isLockedWithEditWarn: boolean; // From isLockedWithEditWarn()
  lockedWarningMessage: string | null; // From getLockedWarningMessage()
  anyCellsLockedOrArchived: boolean; // From _anyCellsLockedOrArchived()
  */
}

/**
 * Creates a memoized selector that computes the TableLockingModel from the store.
 */
export function createTableLockingSelector(): (store: TableEditableStore) => TableLockingModel {
  return createTableModelSelector(
    [(store) => store.stableProps.locked ?? false, (store) => store.stableProps.hasPlaceholderRows ?? false],
    (locked, hasPlaceholderRows) => ({
      isTableLocked: computeIsTableLocked(locked, hasPlaceholderRows),
    })
  );
}
